import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { CONFIRMATION_STATUS } from 'domains/seller-inbound/constants'

const proptypes = {
  confirmation_status: PropTypes.string
}

/**
 * To give nice look on Seller Inbound `confirmation_status`.
 * It maps `confirmation_status` to certain style and pass to `StatusBadge`.
 * @param {string} confirmation_status Seller Inbound confirmation status. available values
 * - `admin_confirmed`
 * - `admin_cancelled`
 * - `seller_confirmed`
 * - `seller_cancelled`
 */
const SellerInboundConfirmationStatusBadge = ({ confirmation_status }) => {

  const colorMap = {
    [CONFIRMATION_STATUS.ADMIN_CONFIRMED]  : 'success',
    [CONFIRMATION_STATUS.SELLER_CONFIRMED] : 'success',
    [CONFIRMATION_STATUS.ADMIN_CANCELLED]  : 'danger',
    [CONFIRMATION_STATUS.SELLER_CANCELLED] : 'danger',
    [CONFIRMATION_STATUS.SYSTEM_CANCELLED] : 'info',
    [CONFIRMATION_STATUS.PENDING]          : 'warning'
  }

  const color = colorMap[confirmation_status] || 'default'

  return <StatusBadge color={ color } label={ confirmation_status } />
}

SellerInboundConfirmationStatusBadge.propTypes = proptypes

export default SellerInboundConfirmationStatusBadge